import { Component, ViewChild } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Company, Apps } from 'src/app/models/interfaces.model';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { catchError, throwError } from 'rxjs';
import { EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-modal-company',
  templateUrl: './modal-company.component.html',
  styleUrls: ['./modal-company.component.css']
})
export class ModalCompanyComponent {
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;
  companyForm: FormGroup;
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter();
  modalTitle: string | null = null;
  company: string | null = null;
  domain: string | null = null;
  dc: string | null = null;
  active: number = 1;
  loading: boolean = false;
  edit: number = 0;
  id: number = -1;
  archivo: File | null = null;
  logo: string | null = null;
  APPS: Apps[] = [];
  ALLAPPS: any;
  selectedApps: any;
  AssociateApp: boolean = false;
  companiesApps: any[] = [];
  fileRemoved: boolean = false;


  constructor(
    private fb: FormBuilder,
    public modalRef: MdbModalRef<ModalCompanyComponent>,
    private crudService: GenericCrudService<Company>) {
    this.companyForm = this.fb.group({
      company: ['', [Validators.required, Validators.minLength(5)]],
      active: [false],
    });
  }

  ngOnInit() {
    this.companyForm.patchValue({
      company: this.company,
      domain: this.domain,
      dc: this.dc,
      active: this.active * 1,
      logo: this.logo
    });
    this.companyForm.addControl('selectedApps', new FormControl());

    if(this.edit == 1){
      
      this.preselectApps();
    }
    

  }

  preselectApps() {
    const selectedValues: string[] = this.APPS?.map((app: any) => app.ID_APP); // Obtenemos los ID_APP de APPS
    this.companyForm.get('selectedApps')?.setValue(selectedValues); // Establecemos los valores seleccionados en el formulario
  }
  
  


  InsertOrUpdate(): void {

    const body = new FormData();
    body.append('action', this.edit == 0 ? "INSERT" : "UPDATE");
    body.append('table_name', "COMPANIES");
    body.append('name', this.companyForm.value.company);
    if (this.active !== null) {
      body.append('active', this.companyForm.value.active ? '1' : '0' );
    }
    if (this.archivo !== null) {
      body.append('logo', this.archivo);
    }

    if (this.edit !== 0) {
      body.append('id', this.id.toString());
    }
    if (this.AssociateApp || this.edit == 1)
    body.append('apps', this.companyForm.value.selectedApps.toString());

    this.loading = true;

    this.crudService.crud(body, environment.CompanyApps).pipe(
      catchError(error => {
        console.error(error);
        ShowInfoSwal(0, 'Error', error.message);
        this.loading = false;
        return throwError(error); // se puede devolver el error original o lanzar un nuevo error personalizado
      })
    ).subscribe((data: any) => {

      ShowInfoSwal(data.status, data.msg, '');
      this.OnGuardarClicked.emit(true);
      this.modalRef.close();
      this.loading = false;
    });
  }

  onCheckboxChange(event: any) {
    const isChecked = event.target.checked;
    this.active = isChecked ? 1 : 0;

    const selectedAppsControl = this.companyForm.get('selectedApps');
    if (selectedAppsControl) {
      if (!this.AssociateApp) {
        selectedAppsControl.setValue([]);
      } else {
        selectedAppsControl.setValue(null);
      }
    }
    else
      this.companyForm.addControl('selectedApps', new FormControl());
  }




  AssociateAppChange(event: any) {
    this.AssociateApp = event.target.checked;

    const selectedAppsControl = this.companyForm.get('selectedApps');
    if (this.AssociateApp) {
      if (!selectedAppsControl) {
        this.companyForm.addControl('selectedApps', new FormControl());
      }
    } else {
      if (selectedAppsControl) {
        this.companyForm.removeControl('selectedApps');
      }
    }

  }

  onFileRemoved(): void {
    this.archivo = null;
  }

  onFileAdded(files: File[]): void {
    this.archivo = files[0];
    /*const formData = new FormData();
    formData.append('file', files[0]);*/

    /*const formArray = this.companyForm.get(formArrayName) as FormArray;
    if (formArray) {
      this.filesToAdd[formArrayName] = this.filesToAdd[formArrayName] || [];
      this.filesToAdd[formArrayName] = this.filesToAdd[formArrayName].concat(
        files.map(file => ({ file, dbColumnName }))
      );
        const controls = formArray.controls as FormControl[];
      controls.forEach((control, i) => {
        control.setValue(this.filesToAdd[formArrayName][i]);
      });
    }*/
  }

}
